<template>
  <div class="size-popover-container" ref="container">
    <input type="text" class="input_e" :value="displayText" placeholder="请输入选择范围" clearable @click="togglePopover"
      readonly />
    <span v-if="displayText" class="clear-icon" @click="clearInputs">×</span>
    <div v-if="isPopoverVisible" class="popover" ref="popover">
      <div class="popover-content">
        <div>
          <label for="width-min">宽</label>
          <input id="width-min" :value="widthMin" @input="updateWidthMin($event.target.value)" placeholder="最小"
            autocomplete="off" />
          -
          <input id="width-max" :value="widthMax" @input="updateWidthMax($event.target.value)" placeholder="最大"
            autocomplete="off" />
        </div>
        <div>
          <label for="height-min">高</label>
          <input id="height-min" :value="heightMin" @input="updateHeightMin($event.target.value)" placeholder="最小"
            autocomplete="off" />
          -
          <input id="height-max" :value="heightMax" @input="updateHeightMax($event.target.value)" placeholder="最大"
            autocomplete="off" />
        </div>
        <button @click="saveDimensions">确认</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SizePopover",
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      isPopoverVisible: false,
    };
  },
  computed: {
    widthMin() {
      return this.value.widthMin || "";
    },
    widthMax() {
      return this.value.widthMax || "";
    },
    heightMin() {
      return this.value.heightMin || "";
    },
    heightMax() {
      return this.value.heightMax || "";
    },
    displayText() {
      const widthText = this.widthMin || this.widthMax ? `宽 ${this.widthMin || ''} - ${this.widthMax || ''}` : '';
      const heightText = this.heightMin || this.heightMax ? `高 ${this.heightMin || ''} - ${this.heightMax || ''}` : '';
      return [widthText, heightText].filter(Boolean).join(' ');
    },
  },
  mounted() {
    // 添加全局点击事件监听器
    document.addEventListener('click', this.handleDocumentClick);
  },
  beforeDestroy() {
    // 移除全局点击事件监听器
    document.removeEventListener('click', this.handleDocumentClick);
  },
  methods: {



    updateWidthMin(value) {
      this.$emit("input", { ...this.value, widthMin: value });
    },
    updateWidthMax(value) {
      this.$emit("input", { ...this.value, widthMax: value });
    },
    updateHeightMin(value) {
      this.$emit("input", { ...this.value, heightMin: value });
    },
    updateHeightMax(value) {
      this.$emit("input", { ...this.value, heightMax: value });
    },
    togglePopover(event) {
      event.stopPropagation();
      this.isPopoverVisible = !this.isPopoverVisible;
    },
    handleDocumentClick(event) {
      // 检查点击事件是否发生在 popover 或者 input 的范围内
      if (!this.$refs.container.contains(event.target) && !this.$refs.popover.contains(event.target)) {
        this.isPopoverVisible = false; // 如果点击不在这些范围内，则关闭 popover
      }
    },

    // 保存输入的尺寸
    saveDimensions() {
      const dimensions = {
        widthMin: this.widthMin,
        widthMax: this.widthMax,
        heightMin: this.heightMin,
        heightMax: this.heightMax,
      };

      // 检查是否有输入内容
      const hasInput =
        this.widthMin !== null ||
        this.widthMax !== null ||
        this.heightMin !== null ||
        this.heightMax !== null;

      if (hasInput) {
        // 如果有输入内容，生成显示文本
        let displayText = '';
        if (this.widthMin !== null || this.widthMax !== null) {
          displayText += `宽 ${this.widthMin || ''} - ${this.widthMax || ''}`;
        }
        if (this.heightMin !== null || this.heightMax !== null) {
          displayText += `${displayText ? ' ' : ''}高 ${this.heightMin || ''} - ${this.heightMax || ''}`;
        }
        this.displayText = displayText;
        this.$emit("save", this.value); // 触发保存事件
      } else {
        // 如果没有输入内容，清空显示文本并触发 clear 事件
        this.displayText = '';
        this.$emit("clear"); // 触发清空事件
      }

      this.isPopoverVisible = false; // 关闭 Popover
    },

    // 清空输入框和显示内容
    clearInputs() {
      this.$emit("input", { widthMin: null, widthMax: null, heightMin: null, heightMax: null });
      this.$emit("clear"); // 触发清空事件
    },
  },
};
</script>
<style scoped>
.size-popover-container {
  position: relative;
  display: inline-block;
  outline: none;
}

.input-container {
  position: relative;
  display: inline-block;
}

.clear-icon {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  font-size: 16px;
  color: #999;
  display: none;
}

.size-popover-container:hover .clear-icon {
  color: #333;
  display: block;
}


.popover {
  position: absolute;
  top: 100%;
  left: 0;
  margin-top: 5px;
  padding: 10px;
  border: 1px solid #ccc;
  background-color: #fff;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  z-index: 1000;
}

.popover-content {
  display: flex;
  flex-direction: column;
  width: 220px;
}

.popover-content label {
  margin-top: 5px;
}

.popover-content input {
  margin-bottom: 10px;
  padding: 5px;
  border: 1px solid #ccc;
  border-radius: 4px;
  outline: none;
  width: 80px;
}

.popover-content button {
  margin-top: 10px;
  padding: 5px 10px;
  background-color: #007bff;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.popover-content button:hover {
  background-color: #0056b3;
}

.input_e {
  width: 160px;
  height: 40px;
  border: 1px solid;
  border-radius: 5px;
  position: relative;
  text-indent: 10px;
  outline: none;
}

.input_e::placeholder {
  text-indent: 10px;
}

.orange .input_e {
  background-color: #bcd9f8d4 !important;
  color: #222222;
}
</style>



// WEBPACK FOOTER //
// src/components/SizePopover.vue